
import React from 'react';
import { Language } from '../types';
import { translations } from '../translations';

const Logo = () => (
  <svg 
    width="48" 
    height="48" 
    viewBox="0 0 48 48" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className="mr-4 drop-shadow-[0_0_12px_rgba(99,102,241,0.4)] shrink-0"
  >
    {/* Cadre de mise en page */}
    <rect x="4" y="4" width="40" height="40" rx="10" stroke="currentColor" strokeWidth="2" className="text-slate-800" />
    
    {/* Axe de séparation central */}
    <path d="M24 6V42" stroke="currentColor" strokeWidth="1" strokeDasharray="4 2" className="text-slate-600" />
    
    {/* Partie "Avant" - Minimaliste/Brut */}
    <rect x="10" y="16" width="10" height="16" rx="3" fill="currentColor" className="text-slate-700" />
    
    {/* Partie "Après" - Vibrant/Gradiant */}
    <rect x="28" y="16" width="10" height="16" rx="3" fill="url(#logo_gradient)" />
    
    {/* Point d'interaction central */}
    <circle cx="24" cy="24" r="3.5" fill="white" stroke="#6366f1" strokeWidth="2" />
    
    <defs>
      <linearGradient id="logo_gradient" x1="28" y1="16" x2="38" y2="32" gradientUnits="userSpaceOnUse">
        <stop stopColor="#818CF8" />
        <stop offset="1" stopColor="#22D3EE" />
      </linearGradient>
    </defs>
  </svg>
);

interface HeaderProps {
  language: Language;
  onLanguageChange: (lang: Language) => void;
}

export const Header: React.FC<HeaderProps> = ({ language, onLanguageChange }) => {
  const t = translations[language];

  return (
    <header className="w-full flex flex-col md:flex-row justify-between items-center mb-12 border-b border-slate-800 pb-8 gap-4">
      <div className="flex items-center">
        <Logo />
        <div>
          <h1 className="text-4xl font-black italic tracking-tighter text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-cyan-400">PERSPECTIVE</h1>
          <p className="text-slate-500 text-xs font-bold tracking-widest mt-1 uppercase">{t.header_subtitle}</p>
        </div>
      </div>

      <div className="flex bg-slate-900 border border-slate-800 p-1 rounded-xl">
        {(['fr', 'en', 'es'] as Language[]).map((lang) => (
          <button
            key={lang}
            onClick={() => onLanguageChange(lang)}
            className={`px-3 py-1.5 rounded-lg text-xs font-black uppercase transition-all ${
              language === lang 
                ? 'bg-indigo-600 text-white shadow-lg' 
                : 'text-slate-500 hover:text-slate-300'
            }`}
          >
            {lang}
          </button>
        ))}
      </div>
    </header>
  );
};
